"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tribute = exports.ProductDonationRecurrenceInterval = void 0;
var ProductDonationRecurrenceInterval;
(function (ProductDonationRecurrenceInterval) {
    ProductDonationRecurrenceInterval["OneTime"] = "oneTime";
    ProductDonationRecurrenceInterval["Weekly"] = "weekly";
    ProductDonationRecurrenceInterval["BiWeekly"] = "biWeekly";
    ProductDonationRecurrenceInterval["Monthly"] = "monthly";
    ProductDonationRecurrenceInterval["Quarterly"] = "quarterly";
    ProductDonationRecurrenceInterval["Yearly"] = "yearly";
})(ProductDonationRecurrenceInterval || (exports.ProductDonationRecurrenceInterval = ProductDonationRecurrenceInterval = {}));
var Tribute;
(function (Tribute) {
    Tribute["InMemoryOf"] = "inMemoryOf";
    Tribute["InHonourOf"] = "inHonourOf";
})(Tribute || (exports.Tribute = Tribute = {}));
